import script from "./SendAuthentication.vue?vue&type=script&setup=true&lang=js"
export * from "./SendAuthentication.vue?vue&type=script&setup=true&lang=js"

import "./SendAuthentication.vue?vue&type=style&index=0&id=5526f501&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5526f501"]])

export default __exports__